import { Button, Card, CardTitle, Input } from "@dune/ui";
import "@dune/ui/globals.css";
import { useState } from "react";
import { useGetOneOriasDetailsByNumberForRegister } from "../../api/mutations/orias.mutations";

export default function GetOriasDetails() {
	const [oriasNumber, setOriasNumber] = useState("");

	const { mutateAsync, isPending } = useGetOneOriasDetailsByNumberForRegister();
	const isButtonDisabled = oriasNumber.length !== 8 || isPending;

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setOriasNumber(e.target.value);
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (isButtonDisabled) return;
		await mutateAsync(oriasNumber);
	};

	return (
		<div className="bg-background-blue h-screen flex items-center justify-center">
			<div className="absolute top-0 left-0 p-6">
				<img src="/dune_white_logo.png" alt="Dune Logo" className="w-32" />
			</div>
			<div>
				<Card className="p-10 flex flex-col gap-8 max-w-[420px] overflow-auto text-center">
					<CardTitle className="text-4xl">Devenez partenaire Dune !</CardTitle>
					<form
						onSubmit={handleSubmit}
						className="flex flex-col gap-8"
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								e.preventDefault();
								handleSubmit(e);
							}
						}}
					>
						<div className="flex flex-col items-start gap-3">
							<div>Numéro ORIAS</div>
							<Input
								placeholder="8 chiffres"
								className="h-11"
								onChange={handleInputChange}
								value={oriasNumber}
								maxLength={8}
							/>
						</div>
						<Button
							className="h-11"
							type="submit"
							disabled={isButtonDisabled}
							isLoading={isPending}
						>
							Suivant
						</Button>
					</form>
					<div>
						Vous avez déjà un compte ?&nbsp;
						<a
							href="/login"
							className="text-text-blue hover:text-blue-700 font-semibold"
						>
							Connectez-vous
						</a>
					</div>
				</Card>
			</div>
		</div>
	);
}
